import { Welcome } from "../components/Welcometext";
import { useDispatch } from "react-redux";
import { useAuth } from "../hooks/use-auth";
import React, { useState } from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import "../components/style.css"



const WelcomePage = () => {




    let navigate = useNavigate();

    return(
        <div>
          <div className="wrapper">
            <Welcome/>
          </div>
           
        </div>
    )
}

export {WelcomePage};